export default __webpack_public_path__ + "static/media/times-new-roman.5f0d1de1.ttf";